import { TYPES } from './types'

export const setKanban = (value: boolean) => ({
  type: TYPES.SET_KANBAN,
  value
})

export const getKanbanSaga = () => ({
  type: TYPES.GET_KANBAN_SAGA
})
